import { Text, View } from 'react-native'

export default function () {
  return <></>
}
